var exports = {
  "kL": "x8b4e8595--827aea--container",
  "Sl": "x8b4e8595--827aea--image",
  "q9": "x8b4e8595--827aea--price",
  "BI": "x8b4e8595--827aea--favorite",
  "q3": "x8b4e8595--827aea--visited-label",
  "rf": "x8b4e8595--827aea--body",
  "mZ": "x8b4e8595--827aea--price-value",
};

module.exports = exports;
